<script setup lang="ts">
import dateHelper from "../../helpers/dateHelper";
import {computed, ref, watch} from "vue";
import formatHelper from "@/core/helpers/formatHelper";
import Icon from "@/core/components/icon/Icon.vue";

const {editable = true, ...props} = defineProps<{
    name: string;
    onboarded?: boolean;
    birthDate?: string | null;
    phone?: string;
    editable?: boolean;
}>();

const emits = defineEmits([
    'input'
]);

const isValid = ref(true);
const validationMessage = ref('');

const handleInputChange = (event) => {
    const value = event.target.value.replace(/\D/g, '');

    emits('input', value);
};

const formattedInput = computed(() => {
    return formatHelper.readablePhone(props.phone);
});

watch(() => props.phone, (newValue) => {
    if (newValue) {
        isValid.value = formatHelper.phoneIsValid(newValue);
        validationMessage.value = isValid.value ? '' : 'Numéro de téléphone invalide';
    } else {
        isValid.value = true;
        validationMessage.value = '';
    }
});
</script>

<template>
  <div class="flex gap-1 items-center">
    <div v-if="onboarded !== null">
      <img v-if="onboarded" alt="Certifié" src="@/assets/icons/certified.svg">
      <Icon v-else name="mdi-cellphone" color="gray" :size="35" />
    </div>
    <div class="flex flex-col justify-between">
      <p class="text-primary font-bold">
        {{ name }} <span v-if="birthDate" class="text-sm text-gray-500">{{ dateHelper.age(birthDate) }}</span>
      </p>
      <div>
        <input
          :value="formattedInput"
          class="px-0 py-0 rounded-md self-start focus:ring-0"
          maxlength="14"
          placeholder="__ __ __ __ __"
          :disabled="!editable"
          @input="handleInputChange"
        >
        <div>
          <slot name="error" />
          <p v-if="!$slots['error']" class="text-sm text-red-600">
            {{ validationMessage }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
